module.exports = __webpack_public_path__ + "static/testimonial-headshot-4.4fb1e5ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials/testimonial-headshot-4.png
// module id = 980
// module chunks = 208176855801404